define.alias("shared/utils/array-filters/get-sum-of-extracted-values", "media/utils/array-filters/get-sum-of-extracted-values");